export const capitalize = (name = "") => {
  return name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
};

export const capitalizeName = (name = "") => {
  return name ? name.trim().split(" ").map(part => capitalize(part)).join(" ").split("-").map(part => capitalize(part)).join("-") : "";
};